(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown(section) {
    var endValue = section.dataset.countdownEnd;
    if (!endValue) return;

    var endDate = new Date(endValue);
    if (isNaN(endDate.getTime())) return; // geçersiz/boş tarih formatı — sessizce çık

    var daysEl = section.querySelector('[data-cd-days]');
    var hoursEl = section.querySelector('[data-cd-hours]');
    var minutesEl = section.querySelector('[data-cd-minutes]');
    var secondsEl = section.querySelector('[data-cd-seconds]');

    function tick() {
      var diff = endDate.getTime() - Date.now();

      if (diff <= 0) {
        section.classList.add('is-expired');
        clearInterval(timerId);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    var timerId = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('.countdown-deal[data-countdown-end]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
